
import { defineComponent, PropType } from 'vue'

interface NavItem {
  label: string
  routePath: string
  separator?: boolean
}

export default defineComponent({
  name: 'SubSidebarLayout',
  inheritAttrs: true,
  props: {
    as: {
      type: String,
      default: 'div'
    },
    constrained: {
      type: Boolean,
      default: false
    },
    navItems: {
      type: Array as PropType<NavItem[]>,
      default: () => []
    }
  }
})
